import { createGlobalStyle } from "styled-components";

// Font files resolve through the bundler; `require` matches PaymentForm.tsx (no
// module declaration exists for .woff2).
const interLightUrl: string = require("@fonts/Inter/Inter-Light.woff2");
const interMediumItalicUrl: string = require("@fonts/Inter/Inter-MediumItalic.woff2");

// The two Inter cuts the admin type scale needs beyond the Regular and Medium
// the app already registers (XCUT-R9, XCUT-R37).
export const adminFontFaceCss = `
  @font-face {
    font-family: Inter-Light;
    src: url(${interLightUrl}) format("woff2");
    font-style: normal;
    font-weight: normal;
    font-display: swap;
  }

  @font-face {
    font-family: Inter-MediumItalic;
    src: url(${interMediumItalicUrl}) format("woff2");
    font-style: italic;
    font-weight: normal;
    font-display: swap;
  }
`;

// Mounted only inside the rebuilt admin (XCUT-R14), so nothing about the patient
// app or the legacy admin changes.
const AdminFonts = createGlobalStyle`
  ${adminFontFaceCss}
`;

export default AdminFonts;
